
        export default {"base":"components/HeaderImage/themes/base.js"};
    